import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//VIEWS
import Layout from "./components/Layout/Layout";
import Home from "./views/Home/Home";
import CarList from "./views/CarList/CarList";
import Models from "./views/Models/Models";
import Operations from "./views/Operations/Operations";
import Brands from "./views/Brands/Brands";

//CSS
import 'devextreme/dist/css/dx.light.css';

function App() {
  return (
    <Router>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Layout>
        <Routes>
          <Route path="/" Component={Home} />
          <Route path="/lista-carros" Component={CarList} />
          <Route path="/modelos" Component={Models} />
          <Route path="/marcas" Component={Brands} />
          <Route path="/operaciones" Component={Operations} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
